import { createStore } from 'store';
import { getGlobalRouter } from '@okapi/router-react';
import log from 'loglevel';
import { registerApp } from '@okapi/core';
import { getLayers } from 'store/header-middleware/utils/get-layers';
import { UNHANDLED_SAGA_ERROR } from 'features/errors-hook';
import { initI18n, getDomain } from 'utils';
import { createEntry, getInitialData } from '../common';
import { rootSaga } from './root-saga';

const preloadedState = getInitialData();

const { CLIENT_LOG_LEVEL = 'error' } = preloadedState?.env ?? {};
log.setDefaultLevel(CLIENT_LOG_LEVEL as log.LogLevelDesc);

if (preloadedState.isBot === false) {
  registerApp(__NAME__, buildApplication);
}

function buildApplication() {
  const router = getGlobalRouter();
  const domain = getDomain(preloadedState.host);
  initI18n(router.getPath(), domain);

  const { store, runSaga } = createStore({
    router,
    preloadedState,
    env: preloadedState.env,
    userAgent: window.navigator.userAgent,
    cookie: document.cookie,
    deviceType: preloadedState.deviceType,
    layers: getLayers(document.cookie),
    uuid: preloadedState.experimentsUUID,
  });
  const saga = runSaga(rootSaga);
  saga.toPromise().catch((reason) => {
    store.dispatch(UNHANDLED_SAGA_ERROR(reason));
  });

  const Entry = createEntry({ store, router, remoteContext: undefined });

  return Entry;
}
